import { userHasPermission, userHasRoles } from 'services/Authorization';

export const ensureUserHasAccess = ({ permissions, enabled, roles, user }) => {
  if (!enabled) {
    return false;
  }

  if (permissions) {
    return permissions.some(permission => userHasPermission(permission, user));
  }

  if (roles) {
    return userHasRoles(roles, user);
  }

  return true;
};
